var exports = {
  "vh": "x31de4314--bff9e8--title-highlighted",
  "Vw": "x31de4314--bff9e8--star-rating",
  "VA": "x31de4314--bff9e8--subtitle",
  "nf": "x31de4314--bff9e8--link",
};

module.exports = exports;
